import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

// Import gallery images
import img1 from '../asstes/gallery/1 .jpeg';
import img2 from '../asstes/gallery/2 .jpeg';
import img3 from '../asstes/gallery/3 .jpeg';
import img4 from '../asstes/gallery/4 .jpeg';
import img5 from '../asstes/gallery/5 .jpeg';
import img6 from '../asstes/gallery/6.jpeg';
import img75 from '../asstes/gallery/75.jpeg';
import slider1 from '../asstes/gallery/slider1.jpeg';
import slider2 from '../asstes/gallery/slider2.jpeg';
import slider3 from '../asstes/gallery/slider3.jpeg';
import slider4 from '../asstes/gallery/slider4.jpeg';
import slider5 from '../asstes/gallery/slider5.jpeg';
import slider6 from '../asstes/gallery/slider6.jpeg';
import gram from '../asstes/gallery/gramsevak.jpeg';
import zp from '../asstes/gallery/zp.jpg.jpeg';

const WebsiteGallery = () => {
  const { language } = useLanguage();
  const [selectedCategoryId, setSelectedCategoryId] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const galleryImages = [
    { id: 1, src: img1, title: { marathi: 'ग्रामपंचायत कार्यालय', english: 'Gram Panchayat Office' }, categoryId: 'development' },
    { id: 2, src: img2, title: { marathi: 'सामुदायिक कार्यक्रम', english: 'Community Event' }, categoryId: 'social' },
    { id: 3, src: img3, title: { marathi: 'विकास प्रकल्प', english: 'Development Project' }, categoryId: 'development' },
    { id: 4, src: img4, title: { marathi: 'ग्रामीण विकास', english: 'Rural Development' }, categoryId: 'development' },
    { id: 5, src: img5, title: { marathi: 'जनसेवा कार्यक्रम', english: 'Public Service Event' }, categoryId: 'social' },
    { id: 6, src: img6, title: { marathi: 'ग्रामपंचायत उपक्रम', english: 'Gram Panchayat Activity' }, categoryId: 'development' },
    { id: 7, src: img75, title: { marathi: 'विशेष कार्यक्रम', english: 'Special Event' }, categoryId: 'social' },
    { id: 8, src: slider1, title: { marathi: 'गावाचा विकास', english: 'Village Development' }, categoryId: 'development' },
    { id: 9, src: slider2, title: { marathi: 'सार्वजनिक सुविधा', english: 'Public Facilities' }, categoryId: 'development' },
    { id: 10, src: slider3, title: { marathi: 'ग्रामीण परिसर', english: 'Rural Area' }, categoryId: 'development' },
    { id: 11, src: slider4, title: { marathi: 'सामुदायिक उपक्रम', english: 'Community Activity' }, categoryId: 'social' },
    { id: 12, src: slider5, title: { marathi: 'ग्रामपंचायत कार्य', english: 'Gram Panchayat Work' }, categoryId: 'development' },
    { id: 13, src: slider6, title: { marathi: 'जिल्हा परिषद कार्य', english: 'Zilla Parishad Work' }, categoryId: 'development' },
    { id: 14, src: gram, title: { marathi: 'ग्रामपंचायत', english: 'Gram Panchayat' }, categoryId: 'development' },
    { id: 15, src: zp, title: { marathi: 'जिल्हा परिषद', english: 'Zilla Parishad' }, categoryId: 'development' },
  ];
  
  const categories = [
    { id: 'all', marathi: 'सर्व फोटो', english: 'All Photos' },
    { id: 'development', marathi: 'विकासकामे', english: 'Development Work' },
    { id: 'social', marathi: 'सामाजिक कार्यक्रम', english: 'Social Events' },
    { id: 'festivals', marathi: 'सण आणि उत्सव', english: 'Festivals' }
  ];
  
  const filteredImages = selectedCategoryId === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.categoryId === selectedCategoryId);

  const getCategoryName = (catId) => {
    const cat = categories.find(c => c.id === catId);
    if (!cat) return '';
    return language === 'marathi' ? cat.marathi : cat.english;
  };

  const openImageModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = currentIndex < filteredImages.length - 1 ? currentIndex + 1 : 0;
    } else {
      newIndex = currentIndex > 0 ? currentIndex - 1 : filteredImages.length - 1;
    }
    
    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {language === 'marathi' ? 'ग्रामपंचायत गॅलरी' : 'Gram Panchayat Gallery'}
          </h1>
          <p className="text-lg text-gray-600">
            {language === 'marathi' ? 'इनाम धामणी ग्रामपंचायतीच्या विविध कार्यक्रम आणि उपक्रमांचे फोटो' : 'Photos of various events and activities of Inam Dhamani Gram Panchayat'}
          </p>
          <div className="mt-6 w-32 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto rounded-full"></div>
        </div>

        {/* Gallery Categories */}
        <div className="mb-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategoryId(category.id)}
                className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                  selectedCategoryId === category.id
                    ? 'bg-blue-500 text-white'
                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                }`}
              >
                {language === 'marathi' ? category.marathi : category.english}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredImages.map((image) => (
            <div 
              key={image.id} 
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              onClick={() => openImageModal(image)}
            >
              <div className="aspect-square">
                <img
                  src={image.src}
                  alt={image.title[language] || image.title.marathi}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                  <h3 className="font-bold text-lg mb-1">{image.title[language] || image.title.marathi}</h3>
                  <p className="text-sm opacity-90">{getCategoryName(image.categoryId)}</p>
                </div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="bg-white/90 rounded-full p-3">
                  <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No Images Message */}
        {filteredImages.length === 0 && (
          <div className="mt-16 text-center p-8 bg-white rounded-xl shadow-lg border border-gray-200">
            <div className="text-6xl mb-4">📷</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              {language === 'marathi' 
                ? `${getCategoryName(selectedCategoryId)} श्रेणीतील फोटो उपलब्ध नाहीत` 
                : `No photos available in ${getCategoryName(selectedCategoryId)}`}
            </h2>
            <p className="text-gray-600">
              {language === 'marathi'
                ? 'कृपया दुसरी श्रेणी निवडा किंवा लवकरच येथे नवीन फोटो पाहू शकता.'
                : 'Please select another category or check back soon for new photos.'}
            </p>
          </div>
        )}
      </div>

      {/* Image Modal */}
      {isModalOpen && selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
          <div className="relative max-w-6xl w-full">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center text-gray-800 hover:bg-white transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Previous Button */}
            <button
              onClick={() => navigateImage('prev')}
              className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/90 flex items-center justify-center text-gray-800 hover:bg-white transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Next Button */}
            <button
              onClick={() => navigateImage('next')}
              className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/90 flex items-center justify-center text-gray-800 hover:bg-white transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* Image Container */}
            <div className="bg-white rounded-lg overflow-hidden">
              <img
                src={selectedImage.src}
                alt={selectedImage.title[language] || selectedImage.title.marathi}
                className="w-full h-auto max-h-[80vh] object-contain"
              />
              <div className="p-6 bg-white">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">{selectedImage.title[language] || selectedImage.title.marathi}</h3>
                <p className="text-gray-600">{getCategoryName(selectedImage.categoryId)}</p>
                <div className="mt-4 flex items-center justify-between text-sm text-gray-500">
                  <span>{filteredImages.findIndex(img => img.id === selectedImage.id) + 1} / {filteredImages.length}</span>
                  <span>{language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत' : 'Inam Dhamani Gram Panchayat'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WebsiteGallery;